// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Pastille from "../../resources/feedback-indicators/Pastille.res.js";
import * as TextLink from "../../resources/navigation/TextLink.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as InlineText from "../../resources/layout-and-structure/InlineText.res.js";
import * as CatalogRoutes from "../../app/Catalog/CatalogRoutes.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function LegacyProductReferenceTableCell(props) {
  let __openNewTab = props.openNewTab;
  let errorMessage = props.errorMessage;
  let __disabled = props.disabled;
  let pastilleColor = props.pastilleColor;
  let name = props.name;
  let badge = props.badge;
  let __variation = props.variation;
  let cku = props.cku;
  let id = props.id;
  let variation = __variation !== undefined ? __variation : "primary";
  let disabled = __disabled !== undefined ? __disabled : false;
  let openNewTab = __openNewTab !== undefined ? __openNewTab : false;
  let redirectPageRoute = cku !== undefined ? CatalogRoutes.variantRoute(cku) : (
      id !== undefined ? CatalogRoutes.variantRedirectByIdRoute(id) : CatalogRoutes.baseRoute
    );
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsxs(Stack.make, {
      children: [
        variation === "primary" ? JsxRuntime.jsxs("span", {
            children: [
              pastilleColor !== undefined ? JsxRuntime.jsx(Pastille.make, {
                  color: pastilleColor
                }) : null,
              JsxRuntime.jsx(TextLink.make, {
                text: name,
                to: {
                  TAG: "Route",
                  _0: redirectPageRoute
                },
                openNewTab: openNewTab
              })
            ],
            style: {
              display: "flex",
              columnGap: "5px",
              alignItems: "center"
            }
          }) : JsxRuntime.jsxs(InlineText.make, {
            children: [
              JsxRuntime.jsx(TextStyle.make, {
                children: name + "  ",
                variation: disabled ? "subdued" : "neutral",
                weight: disabled ? "regular" : "medium",
                size: "xsmall",
                lineHeight: "large"
              }),
              badge !== undefined ? JsxRuntime.jsx(Badge.make, {
                  children: badge.text,
                  size: "small",
                  variation: badge.variation
                }) : null
            ]
          }),
        disabled ? null : JsxRuntime.jsx(TextStyle.make, {
            children: props.description,
            variation: "normal",
            size: "tiny",
            lineHeight: "xmedium",
            maxLines: 3
          }),
        errorMessage !== undefined ? JsxRuntime.jsx(Box.make, {
            children: JsxRuntime.jsx(TextStyle.make, {
              children: errorMessage,
              variation: "negative",
              size: "tiny"
            }),
            spaceTop: "xsmall"
          }) : null
      ],
      space: "xxsmall"
    }),
    spaceY: "xsmall",
    grow: true
  });
}

let make = React.memo(LegacyProductReferenceTableCell);

export {
  make,
}
/* make Not a pure module */
